// extracted by mini-css-extract-plugin
module.exports = {"links":"link_list-module--links--1Tqzi","link":"link_list-module--link--xIIc2","webIcon":"link_list-module--webIcon--3qSSq"};